import { Box } from "@mui/material";
import { CalendarIcon } from "@radix-ui/react-icons";
import { AlertCircle, Trash2, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../Utils/Utils";
import {
  ADD_INTENTION,
  LISTE_COMMUNE_SANS_PAGINATION,
  LISTE_PARAMETRE_CONFIG,
  POINT_SERVICE_USER,
  RECHERCHER_SUPERVISEUR_COMMERCIALE,
  SERVICE_PARTNER,
} from "../../Utils/constant";
import doc from "../../assets/images/demande.png";
import { deleteItem, find, store } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";
import { useStoreBatiment } from "../../store/Paramettre/batimentStore";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";
import { useStoreForfait } from "../../store/Paramettre/forfaitStore";
import { useStoreApp } from "../../store/storeApp";
import { useStoreCommune } from "../../store/storeCommune";
import { useStoreServicePartner } from "../../store/storeServicePartner";
import CommuneAutocomplete from "../Widget/CommuneAutoComplete";
import { SubmitButton } from "../Widget/SubmitButton";

export const DemandeIntention = ({ handleNext, numero }) => {
  const [msg, setMsg] = useState("");
  const [typeClient, setTypeClient] = useState(null);
  const [pointServices, setPointService] = useState([]);
  const listeServicePartner = useStoreServicePartner();
  const superviseur = useStoreApp();
  const [numeroSuperviseur, setNumeroSuperviseur] = useState("");
  const code = useStoreApp();
  const [numeroAvantage, setNumeroAvantage] = useState("");
  const [venteEnAttente, setVenteEnAtttente] = useState([]);
  const [ticket, setTicket] = useState(null);
  const navigate = useNavigate();
  const listeCommune = useStoreCommune();
  const [communeId, setCommuneId] = useState(null);
  const [servicePartnerId, setServicePartnerId] = useState("");
  const [pointServiceId, setPointServiceId] = useState("");
  const param = useConfigStore();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const forfaits = useStoreForfait();
  const batiments = useStoreBatiment();
  const typeEquipements = useStoreEquipement();

  useEffect(() => {
    find("/commerciale/abonnement/verifier-ventes-encours").then((result) => {
      if (result.data.donnee.length > 0) {
        setVenteEnAtttente(result.data.donnee);
        document.getElementById("enAttenteVente").showModal();
      }
    });

    find(POINT_SERVICE_USER).then((result) => {
      setPointService(result.data.donnee);
    });
    listeCommune.getData(`${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=`);
    listeServicePartner.getData(SERVICE_PARTNER);
    superviseur.getListSuperviseur(RECHERCHER_SUPERVISEUR_COMMERCIALE);
    typeEquipements.equipement({ page: 0, param: "", size: 10 });
    batiments.batiments({ page: 0, param: "", size: 10 });
  }, []);

  const exit = () => {
    window.history.back();
    localStorage.removeItem("numeroTicket");
    localStorage.removeItem("eligible");
  };

  const submit = (data) => {
    setIsSubmit(true);
    const requestData = {
      ...data,
      statusConfirmation: "CONFIRMER",
      contactSuperviseur: numeroSuperviseur,
      communeId: communeId,
    };
    store(ADD_INTENTION, "application/json", requestData)
      .then((res) => {
        if (res.status === 200) {
          reset();
          setIsSubmit(null);
          toast.success("Intention enregistré");
          console.log(res);
          localStorage.setItem(
            "numeroTicket",
            res?.data?.eligibilite?.numeroTicket,
          );
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setMsg(err?.response?.data?.donnee);
        document.getElementById("errorModal").showModal();
      });
  };
  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
  }, []);
  useEffect(() => {
    if (superviseur?.superviseur?.length === 1) {
      setNumeroSuperviseur(superviseur?.superviseur[0]?.numero);
    }
  }, [superviseur]);

  return (
    <>
      <dialog id="delete" className="modal">
        <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <Trash2 className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Confirmer la suppression
            </h3>
            <p className="text-gray-600 mb-6">
              Êtes-vous sûr de vouloir supprimer ce rôle ? Cette action est
              irréversible.
            </p>
            <div className="flex items-center justify-center gap-3">
              <form method="dialog">
                <button className="px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all duration-200">
                  Annuler
                </button>
              </form>
              <button
                onClick={() => {
                  deleteItem(
                    `commericiale/abonnement/v3/${ticket}/supprimer-vente?motif=`,
                  )
                    .then((res) => {
                      if (res.status === 200) {
                        find(
                          "/commerciale/abonnement/verifier-ventes-encours",
                        ).then((result) => {
                          document.getElementById("delete").close();
                          setVenteEnAtttente(result.data.donnee);
                        });
                      }
                    })
                    .catch((err) => {
                      document.getElementById("delete").close();
                      document.getElementById("error").showModal();
                    });
                }}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
              >
                <Trash2 className="h-4 w-4" />
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      <dialog id="errorModal" className="modal">
        <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-sm font-mtn font-bold text-gray-900 mb-2">
              Oops! Impossible de faire cette action
            </h3>
            <p className="text-xs text-red-500">{msg}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => {
                  document.getElementById("errorModal").close();
                }}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      <dialog id="error" className="modal">
        <div className="modal-box max-w-sm bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Oops! Une erreur s'est produite
            </h3>
            <p className="text-gray-600 mb-6">{msg}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => {
                  document.getElementById("delete").close();
                  document.getElementById("error").close();
                }}
                className="btn-sm rounded-md bg-red-500 text-white"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      <dialog id="enAttenteVente" className="modal">
        <div className="relative modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <h1 className="text-lg font-mtn font-bold">
            Liste des ventes en Attente
          </h1>
          <p className="text-red-500 text-xs">
            Vous avez une ou plusieurs intentions en attente
          </p>
          <button
            onClick={() => {
              document.getElementById("enAttenteVente").close();
            }}
            className="absolute top-7 right-2 rounded-full bg-slate-50 p-1"
          >
            <X size={17} />
          </button>
          <div className="space-y-2 mt-4">
            {venteEnAttente?.map((item) => (
              <div
                key={item?.id}
                className="bg-white rounded-xl border-slate-200 border px-3 py-2 shadow-sm"
              >
                <div className="mb-4 flex gap-2 items-center">
                  <p className="text-xs font-bold">
                    Ticket N°{item?.numeroTicket}
                  </p>
                  <p className="ml-auto text-xs flex gap-1 items-center font-medium">
                    <CalendarIcon />
                    {item?.dateCreation
                      ? new Date(item?.dateCreation).toLocaleString()
                      : "--"}
                  </p>
                </div>

                <div className="items-center">
                  <p className="text-xs flex gap-1">
                    Nom du client :{item?.nomClient}{" "}
                  </p>
                </div>

                <div className="my-1 flex items-center">
                  <div className="flex items-center gap-2">
                    <div
                      className={`px-3 border rounded-full py-1 text-xs text-orange-600 font-semibold`}
                    >
                      {item?.etape?.toLowerCase().replace(/_/g, " ")}
                    </div>
                  </div>
                </div>

                <div className="mt-3 space-y-1 mb-2">
                  <div className="flex gap-1">
                    <button
                      onClick={() => {
                        navigate(
                          `${HOME}/abonnements/poursuivre-intention/${
                            item?.numeroTicket
                          }/${
                            item?.etape === "EN_ATTENTE_DE_PAIEMENT"
                              ? 2
                              : item?.etape === "EN_ATTENTE_DE_LIVRAISON"
                                ? 3
                                : item?.etape === "EN_ATTENTE_DE_IDENTIFICATION"
                                  ? 4
                                  : 5
                          }`,
                        );
                        window.location.reload();
                      }}
                      className="btn btn-sm bg-main text-xs"
                    >
                      Poursuivre
                    </button>
                    <button
                      onClick={() => {
                        setTicket(item?.id);
                        document.getElementById("delete").showModal();
                      }}
                      className="rounded-lg btn-sm text-red-600 bg-red-50 text-xs"
                    >
                      Suprimer la vente
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </dialog>

      {isSubmit === null ? (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={doc} height={80} width={80} alt="" />
            <p className="font-light mt-2  text-sm">
              Intention d'abonnement enregistrée
            </p>
          </div>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit(submit)}
          className="shadow-sm border rounded w-fit lg:w-full p-3"
        >
          <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Enregistrer une intention
          </h1>

          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
            <label className="form-control xl:w-1/2  lg:w-1/2  md:w-1/2  w-full">
              <div className="label -mb-1">
                <span className="label-text font-medium">
                  N° ticket <span className="text-red-500">*</span>
                </span>
              </div>
              <input
                {...register("numeroTicket", { required: true })}
                type="text"
                defaultValue={numero}
                readOnly
                placeholder="N° de ticket de vérification "
                className="input input-bordered w-full h-10 text-sm "
              />
            </label>
          </div>

          <div className="my-3">
            <h2 className=" font-medium">Client</h2>
            <hr />
          </div>

          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">
              <div>
                <label className="text-sm">
                  Nom et prenoms <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("nomPrenoms", { required: true })}
                  type="text"
                  placeholder="Nom & prénoms "
                  className="input input-bordered w-full h-10 text-sm "
                />
                {errors.nomPrenoms && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div className="">
                <label className="text-sm">Email</label>
                <input
                  {...register("email")}
                  type="email"
                  placeholder="Email"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>

              <div>
                <label className="text-sm">
                  Numero Client <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("contatct", { required: true })}
                  type="number"
                  min={0}
                  placeholder="Contact client"
                  className="input input-bordered w-full h-10 text-sm "
                />
                {errors.contatct && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">Second contact</label>
                <input
                  {...register("secondContact")}
                  type="number"
                  min={0}
                  placeholder="Second contact client"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>
              {param?.data?.CHAMPS_NUMERO_AVANTAGE === "true" ||
              param?.data?.CHAMPS_NUMERO_AVANTAGE === null ? (
                <div>
                  <label className="text-sm">
                    Numero avantage <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    {...register("numeroAvantage", { required: true })}
                    onChange={(e) => {
                      setNumeroAvantage(e.target.value);
                    }}
                    min={0}
                    placeholder="Numero pour les avantages"
                    className="input input-bordered w-full h-10 text-sm "
                  />
                  {errors.numeroAvantage && (
                    <p className="text-red-600 text-xs">Champs obligatoire</p>
                  )}
                </div>
              ) : null}

              <div>
                <label className="text-sm">
                  Type de client <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("typeClient", { required: true })}
                  onChange={(e) => setTypeClient(e.target.value)}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    type de client
                  </option>
                  <option value="PARTICULIER">Particulier</option>
                  <option value="ENTREPRISE">Entreprise</option>
                </select>
                {errors.typeClient && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              {typeClient === "ENTREPRISE" ? (
                <div>
                  <label className="text-sm">
                    Nom de l'entreprise <span className="text-red-500">*</span>
                  </label>
                  <input
                    {...register("nomEntreprise", { required: true })}
                    type="text"
                    placeholder="Entreprise ...."
                    className="input input-bordered w-full h-10 text-sm "
                  />
                  {errors.nomEntreprise && (
                    <p className="text-red-600 text-xs">Champs obligatoire</p>
                  )}
                </div>
              ) : null}

              <div>
                <label className="text-sm">
                  Type d'équipement <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("equipementId", { required: true })}
                  className="select select-bordered w-full h-10"
                  onChange={(e) => {
                    forfaits.forfaitByEquipe(e.target.value);
                  }}
                >
                  <option value={""} disabled selected>
                    type d'équipement
                  </option>
                  {typeEquipements?.data?.equipements?.map((item) => (
                    <option value={item.id}>{item.designation}</option>
                  ))}
                </select>
                {errors.equipementId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">
                  Forfait <span className="text-red-500">*</span>
                </label>

                <select
                  {...register("forfaitId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    Choisir un forfait
                  </option>
                  {forfaits?.ListForfait?.map((item) => (
                    <option value={item?.id}>
                      {item?.designation} -{" "}
                      {item?.categorie?.replace("_", " ").toLowerCase()}
                    </option>
                  ))}
                </select>
                {errors.forfaitId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div className="my-2">
                <label className="text-sm">
                  Type de batiment <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("batimentId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    type de batiment
                  </option>
                  {batiments?.data?.batiments?.map((item) => (
                    <option value={item.id}>{item.designation}</option>
                  ))}
                </select>
                {errors.batimentId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div className="my-2">
                <label className="text-sm">Point service</label>
                <select
                  value={
                    pointServices?.length === 1
                      ? pointServices[0]?.id
                      : pointServiceId
                  }
                  {...register("pointServiceId")}
                  onChange={(e) => setPointServiceId(e.target.value)}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    selectionnez un point service
                  </option>
                  {pointServices?.map((item) => (
                    <option value={item.id}>{item.designation}</option>
                  ))}
                </select>
                {errors.pointServiceId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>
              {superviseur?.superviseur?.length > 1 ? (
                <>
                  <div className="my-2">
                    <label className="text-sm">
                      Superviseur <span className="text-red-500">*</span>
                    </label>
                    <select
                      {...register("nomSuperviseur", { required: true })}
                      onChange={(e) => {
                        setNumeroSuperviseur(
                          superviseur?.superviseur?.find(
                            (item) => item.nomPrenoms === e.target.value,
                          )?.numero,
                        );
                      }}
                      className="select select-bordered w-full h-10"
                    >
                      <option value={""} selected>
                        selectionnez un superviseur
                      </option>
                      {superviseur?.superviseur?.map((item) => (
                        <option value={item.nomPrenoms}>
                          {item.nomPrenoms}
                        </option>
                      ))}
                    </select>
                    {errors.nomSuperviseur && (
                      <p className="text-red-600 text-xs">Champs obligatoire</p>
                    )}
                  </div>

                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l’agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Contact du superviseur"
                      value={numeroSuperviseur}
                      className="input input-bordered w-full h-10 text-sm "
                      readOnly
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="text-sm">
                      Nom du superviseur ou de l’agence{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("nomSuperviseur")}
                      placeholder="Nom du superviseur"
                      defaultValue={superviseur?.superviseur[0]?.nomPrenoms}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l’agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      {...register("contactSuperviseur")}
                      placeholder="Contact du superviseur"
                      value={numeroSuperviseur}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                </>
              )}

              <div>
                <label className="text-sm">
                  Service partner <span className="text-red-500">*</span>
                </label>
                <select
                  value={
                    listeServicePartner?.data?.donnee?.length === 1
                      ? listeServicePartner?.data?.donnee[0]?.id
                      : servicePartnerId
                  }
                  {...register("servicePartnerId", { required: true })}
                  onChange={(e) => setServicePartnerId(e.target.value)}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    Choisir une service
                  </option>
                  {listeServicePartner?.data?.donnee?.map((item) => (
                    <option value={item?.id}>{item?.designation}</option>
                  ))}
                </select>
                {errors.servicePartner && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              {/* {listeServicePartner?.data?.donnee?.length > 1 ? (
                <>
                  <div>
                    <label className="text-sm">
                      Service partner <span className="text-red-500">*</span>
                    </label>
                    <select
                      {...register("servicePartnerId", { required: true })}
                      onChange={(e) => setTypeClient(e.target.value)}
                      className="select select-bordered w-full h-10"
                    >
                      <option value={""} selected>
                        Choisir une service
                      </option>
                      {listeServicePartner?.data?.donnee?.map((item) => (
                        <option value={item?.id}>{item?.designation}</option>
                      ))}
                    </select>
                    {errors.servicePartner && (
                      <p className="text-red-600 text-xs">Champs obligatoire</p>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="text-sm">
                      Service partner <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("servicePartnerId")}
                      placeholder="Service partner"
                      defaultValue={
                        listeServicePartner?.data?.donnee?.length > 0
                          ? listeServicePartner?.data?.donnee[0]?.designation
                          : ""
                      }
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l’agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      {...register("contactSuperviseur")}
                      placeholder="Contact du superviseur"
                      value={numeroSuperviseur}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                </>
              )} */}

              {/* <div>
                <label className="text-sm">
                  Commune <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("communeId", { required: true })}
                  onChange={(e) => setTypeClient(e.target.value)}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    Choisir une commune
                  </option>
                  {listeCommune?.data?.map((item) => (
                    <option value={item?.id}>{item?.designation}</option>
                  ))}
                </select>
              </div> */}

              <CommuneAutocomplete
                setValue={setCommuneId}
                listeCommune={listeCommune}
              />

              <div>
                <label className="text-sm">Quartier</label>
                <input
                  {...register("quartier")}
                  type="text"
                  placeholder="quartier du client"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>
            </label>
          </div>

          {param?.data?.CHAMPS_OTP === "true" ||
          param?.data?.CHAMPS_OTP === null ? (
            <label className="form-contro  w-full">
              <div className="label -mb-1">
                <span className="label-text font-medium ">
                  Code de confirmation <span className="text-red-500">*</span>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <input
                  {...register("otp", { required: false })}
                  type="text"
                  placeholder="Code de confirmation du client"
                  className="input input-bordered w-full h-10 text-sm font-semibold"
                />
                <span
                  onClick={() => {
                    code.generate(numero, numeroAvantage);
                  }}
                  className="btn btn-sm bg-main"
                >
                  {code?.codeLoading && code?.code === null ? (
                    <>
                      <span className="loading loading-spinner loading-xs mx-2"></span>
                      generation du code
                    </>
                  ) : (
                    "Generer"
                  )}
                </span>
              </div>
              <div className="ml-1">
                <p className="text-xs mt-2 text-amber-500">
                  {code?.code !== null ? `Code généré avec succès` : ""}
                </p>
              </div>
            </label>
          ) : null}

          {isSubmit === null ? null : (
            <SubmitButton
              isSubmit={isSubmit}
              label={"Enregistrer l'intention"}
            />
          )}
        </form>
      )}
      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <button
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={isSubmit !== null ? exit : handleNext}
          >
            {isSubmit !== null ? "Quitter" : "Poursuivre"}
          </button>
        </div>
      </div>
    </>
  );
};
